export class CustomReturn {
    public static Succeed: string = '1';
    public static Failed: string = '2';
    public static ValidationError: string = '3'; 
}
